export const getCorrectPathname = (asPath: string) => {
    const regex = /[.;*`|~(&)=:$±%#@,!<>]|[\][{}]/gi;

    return asPath.split('?')[0].replace(regex, '');
};
